
/**
* Functionality for the sliders
*/
export default function sliders ($) {

  const body = $('body');
	// Run slider functions only on pages where they exists  (Home/Producer/Shows/CS Shows)
	if (body.hasClass("home") || body.hasClass("single-producer") || body.hasClass("single-show") || body.hasClass("single-cs-show") ) {

    $('#slider-hero').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        arrows: true,

      });

      $('#slider-hero').on('beforeChange', function(event, slick, currentSlide){

        var vid = $(slick.$slides[currentSlide]).find('.video-js');

        if (vid.length > 0){
          var vidID = $(vid).attr('id')
          videojs.getPlayer(vidID).ready(function() {
            console.log('video should pause')
            var myPlayer = this;
            myPlayer.pause()
          });

        } else{
          console.log('no vid')
        }
    });

      $('#slider-quotes').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
      });
  }
}



